import retrieveCustomChecklist from 'app/shared/customChecklist/sagas/retrieveCustomChecklist';
import retrieveCustomChecklistSubmission from 'app/shared/customChecklist/sagas/retrieveCustomChecklistSubmission';

const sagaRegistry = [
  retrieveCustomChecklist,
  retrieveCustomChecklistSubmission,
];

export default sagaRegistry;
